
    <template>
      <section class="relax-doc">
        <h1>Drawer 抽屉</h1>
<blockquote>
<p>屏幕边缘滑出的浮层面板</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;primary&quot; @click=&quot;visible = true&quot;&gt;打开&lt;/x-button&gt;
  &lt;x-Drawer title=&quot;标题&quot; v-model=&quot;visible&quot; @close=&quot;cancel&quot; @ok=&quot;ok&quot;&gt;
    default
  &lt;/x-Drawer&gt;
&lt;/template&gt;

&lt;script&gt;
  import { ref, getCurrentInstance } from 'vue';
  export default {
    setup() {
      const instance = getCurrentInstance();
      const { $message } = instance.appContext.config.globalProperties;
      const visible = ref(false);

      const ok = () =&gt; {
        $message.success('点击了确定');
      };

      const cancel = () =&gt; {
        $message('点击了取消');
      };

      return {
        visible,
        ok,
        cancel,
      };
    },
  };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")
  const _component_x_Drawer = _resolveComponent("x-Drawer")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "primary",
      onClick: $event => (_ctx.visible = true)
    }, {
      default: _withCtx(() => [
        _createTextVNode("打开")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_Drawer, {
      title: "标题",
      modelValue: _ctx.visible,
      "onUpdate:modelValue": $event => ((_ctx.visible) = $event),
      onClose: _ctx.cancel,
      onOk: _ctx.ok
    }, {
      default: _withCtx(() => [
        _createTextVNode(" default ")
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue", "onClose", "onOk"])
  ], 64))
}
  
    
        const { ref, getCurrentInstance } = Vue
        ;
  const democomponentExport = {
    setup() {
      const instance = getCurrentInstance();
      const { $message } = instance.appContext.config.globalProperties;
      const visible = ref(false);

      const ok = () => {
        $message.success('点击了确定');
      };

      const cancel = () => {
        $message('点击了取消');
      };

      return {
        visible,
        ok,
        cancel,
      };
    },
  };
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  